import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const createAuthoringSchedule = api(async function createAuthoringSchedule({
    projectId,
    code,
    title,
    legacyScheduleTypes,
    legacyScheduleGroups,
    unitOfMeasure,
}) {
    return mutate(
        gql`
            mutation CreateAuthoringSchedule(
                $projectId: String!
                $code: String!
                $title: String!
                $legacyScheduleTypes: [Int!]!
                $legacyScheduleGroups: [Int!]!
                $unitOfMeasure: String!
            ) {
                createAuthoringSchedule(
                    projectId: $projectId
                    code: $code
                    title: $title
                    legacyScheduleTypes: $legacyScheduleTypes
                    legacyScheduleGroups: $legacyScheduleGroups
                    unitOfMeasure: $unitOfMeasure
                )
            }
        `,
        {
            projectId,
            code,
            title,
            legacyScheduleTypes,
            legacyScheduleGroups,
            unitOfMeasure,
        },
        { returns: "createAuthoringSchedule" }
    )
})
